import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSupportArticle, useSupportContent } from '../../config/queries'
import NotFound from '../Error/NotFound'
import { isSupportSectionSlug } from './sections'
import SupportLayout from './SupportLayout'
import SupportArticleContent from './SupportArticleContent'
import SupportContentSkeleton from './SupportContentSkeleton'
import { htmlExcerpt } from '../../helpers/seo'

const SupportArticlePage = () => {
  const { section: sectionParam, slug } = useParams()
  const { t } = useTranslation()
  const { data: content, isPending: contentPending } = useSupportContent()
  const {
    data: article,
    isPending,
    isError,
  } = useSupportArticle(sectionParam, slug)

  if (!sectionParam || !slug || !isSupportSectionSlug(sectionParam)) {
    return <NotFound />
  }

  const section = sectionParam
  const articles = content?.articlesBySection[section] ?? []

  if (isError) return <NotFound />

  return (
    <SupportLayout
      section={section}
      articles={articles}
      articlesPending={contentPending}
      title={article?.title ?? t(`support.sections.${section}.title`)}
      titlePending={isPending || !article}
      description={htmlExcerpt(article?.content)}
    >
      {contentPending || isPending || !article ? (
        <SupportContentSkeleton />
      ) : (
        <SupportArticleContent
          key={`${section}/${slug}`}
          content={article.content}
        />
      )}
    </SupportLayout>
  )
}

export default SupportArticlePage
